import { Logo } from "@/components/Logo";
import { useI18n } from "@/context/I18nContext";

const partners = [
  "Saudi Aramco", "PIF", "NEOM", "GACA", "King Abdulaziz Intl", "Red Sea Mall", "Kingdom Holdings", "Ministry of Housing",
];

export default function Footer() {
  const { t } = useI18n();

  return (
    <footer className="bg-secondary text-secondary-foreground" data-testid="footer">
      <div className="border-b border-white/10 overflow-hidden">
        <div className="flex marquee-track py-6 gap-16 whitespace-nowrap text-secondary-foreground/40 text-sm uppercase tracking-[0.3em]">
          {[...partners, ...partners, ...partners].map((p, i) => (
            <span key={i} className="flex items-center gap-16">
              <span>{p}</span>
              <span className="h-1 w-1 rounded-full bg-primary/60" />
            </span>
          ))}
        </div>
      </div>

      <div className="container-page py-16">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Logo light />
            <p className="mt-6 max-w-sm text-secondary-foreground/65 text-sm leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>
          <div className="lg:col-span-2">
            <div className="overline">{t.footer.servicesTitle}</div>
            <ul className="mt-4 space-y-2 text-sm text-secondary-foreground/70">
              {t.footer.services.map((s, i) => (<li key={i}>{s}</li>))}
            </ul>
          </div>
          <div className="lg:col-span-2">
            <div className="overline">{t.footer.companyTitle}</div>
            <ul className="mt-4 space-y-2 text-sm text-secondary-foreground/70">
              <li><a href="#about" className="hover:text-primary">{t.footer.links.about}</a></li>
              <li><a href="#projects" className="hover:text-primary">{t.footer.links.projects}</a></li>
              <li><a href="#contact" className="hover:text-primary">{t.footer.links.contact}</a></li>
              <li><a href="/login" className="hover:text-primary">{t.footer.links.admin}</a></li>
            </ul>
          </div>
          <div className="lg:col-span-3" data-testid="footer-reach">
            <div className="overline">{t.footer.reachTitle}</div>
            <ul className="mt-4 space-y-2 text-sm text-secondary-foreground/70 leading-relaxed">
              <li>{t.footer.addressLine1}<br />{t.footer.addressLine2}</li>
              <li>
                <a href="tel:+966500338215" className="hover:text-primary transition-colors">+966 50 033 8215</a>
                <span className="mx-2 opacity-40">·</span>
                <a href="tel:+966507974383" className="hover:text-primary transition-colors">+966 50 797 4383</a>
              </li>
              <li><a href="mailto:m.ali@mnh-ksa.com" className="hover:text-primary transition-colors">m.ali@mnh-ksa.com</a></li>
              <li><a href="https://www.mnh-ksa.com" target="_blank" rel="noreferrer" className="hover:text-primary transition-colors">www.mnh-ksa.com</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-wrap items-center justify-between gap-4 text-xs text-secondary-foreground/50">
          <span>© {new Date().getFullYear()} Mohammed Naser Al Hammadi Contracting Co. {t.footer.copyright}</span>
          <span>{t.footer.madeIn}</span>
        </div>
      </div>
    </footer>
  );
}
